var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.334 1.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.245 5.369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1213.876,532.828h-3.932a1.377,1.377,0,0,1-1.384-1.367v-3.982a1.377,1.377,0,0,1,1.384-1.367h3.932a1.378,1.378,0,0,1,1.384,1.367v3.982A1.377,1.377,0,0,1,1213.876,532.828Zm-4.378-3.251v1.884a.438.438,0,0,0,.446.429h3.932a.438.438,0,0,0,.446-.429v-3.982a.438.438,0,0,0-.446-.429h-3.932a.438.438,0,0,0-.446.429Z",
    transform: "translate(-1208.56 -526.112)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.526 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.818 2.108)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.032,
    y1: 1.485,
    transform: "translate(0.352 0.352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.147,516.608a.352.352,0,0,1-.352-.344l-.032-1.485a.352.352,0,0,1,.344-.359h.008a.352.352,0,0,1,.352.344l.032,1.485a.352.352,0,0,1-.344.359Z",
    transform: "translate(-1221.764 -514.419)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1219.35,506.135a.372.372,0,1,1-.269.115.371.371,0,0,1,.269-.115m0-.7a1.076,1.076,0,1,0,.744.3,1.072,1.072,0,0,0-.744-.3Z",
    transform: "translate(-1218.274 -505.431)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.268 1.215)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.813)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 1.122,
    x2: 0.974,
    transform: "translate(0.352 0.352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.4,520.165a.352.352,0,0,1-.266-.582l.974-1.122a.352.352,0,1,1,.531.461l-.974,1.122A.351.351,0,0,1,1236.4,520.165Z",
    transform: "translate(-1236.048 -518.339)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1241.859,511.315a.372.372,0,0,1,.025.743h-.027a.372.372,0,0,1-.025-.743h.027m0-.7-.077,0a1.076,1.076,0,0,0,.075,2.148l.077,0a1.075,1.075,0,0,0-.075-2.148Z",
    transform: "translate(-1240.782 -510.611)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.041 7.302)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.855)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 0.072,
    x2: 1.484,
    transform: "translate(0.352 0.352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.7,538.881a.352.352,0,0,1-.017-.7l1.484-.072a.352.352,0,0,1,.034.7l-1.484.072Z",
    transform: "translate(-1239.344 -538.105)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.141 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1249.55,535.163a.366.366,0,0,1,.25.1.372.372,0,0,1-.25.647.366.366,0,0,1-.25-.1.372.372,0,0,1,.25-.647m0-.7a1.075,1.075,0,1,0,.722.279,1.074,1.074,0,0,0-.722-.279Z",
    transform: "translate(-1248.474 -534.459)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.169 12.573)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 1.052,
    y2: 1.049,
    transform: "translate(0.352 0.352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.029,556.416a.351.351,0,0,1-.248-.1l-1.052-1.049a.352.352,0,1,1,.5-.5l1.052,1.049a.352.352,0,0,1-.249.6Z",
    transform: "translate(-1235.625 -554.663)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.355 1.259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1242.476,560.735a.372.372,0,1,1-.372.372.372.372,0,0,1,.372-.372h0m0-.7h0a1.075,1.075,0,0,0,0,2.151h0a1.075,1.075,0,0,0,0-2.151Z",
    transform: "translate(-1241.401 -560.031)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.804 1.215)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.584 1.813)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.974,
    y1: 1.122,
    transform: "translate(0.352 0.352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.355,520.165a.351.351,0,0,1-.266-.121l-.974-1.122a.352.352,0,0,1,.532-.461l.974,1.122a.352.352,0,0,1-.265.582Z",
    transform: "translate(-1203.029 -518.339)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1197.352,511.315h.027a.372.372,0,0,1-.025.743h-.027a.372.372,0,0,1,.025-.743m0-.7a1.075,1.075,0,0,0-.074,2.148l.077,0a1.076,1.076,0,0,0,.075-2.148l-.077,0Z",
    transform: "translate(-1196.278 -510.611)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.302)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.105 0.855)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1.484,
    y1: 0.072,
    transform: "translate(0.352 0.352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.4,538.881h-.017l-1.484-.072a.352.352,0,0,1,.034-.7l1.484.072a.352.352,0,0,1-.017.7Z",
    transform: "translate(-1197.56 -538.105)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1189.66,535.163a.371.371,0,1,1-.25.1.369.369,0,0,1,.25-.1m0-.7a1.075,1.075,0,1,0,.8.353,1.072,1.072,0,0,0-.8-.353Z",
    transform: "translate(-1188.585 -534.459)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.659 12.573)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.751)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1.052,
    y2: 1.049,
    transform: "translate(0.352 0.352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.474,556.417a.352.352,0,0,1-.248-.6l1.052-1.049a.352.352,0,1,1,.5.5l-1.052,1.049A.351.351,0,0,1,1203.474,556.417Z",
    transform: "translate(-1203.123 -554.663)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1196.734,560.735a.372.372,0,1,1-.372.372.369.369,0,0,1,.372-.372h0m0-.7a1.075,1.075,0,0,0,0,2.151h0a1.075,1.075,0,0,0,0-2.151Z",
    transform: "translate(-1195.658 -560.031)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.526 13.034)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.667 0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.008,
    y2: 1.486,
    transform: "translate(0.352 0.352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.47,558.819h0a.352.352,0,0,1-.35-.354l.008-1.486a.352.352,0,0,1,.352-.35h0a.352.352,0,0,1,.35.354l-.008,1.486A.352.352,0,0,1,1221.47,558.819Z",
    transform: "translate(-1221.118 -556.63)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1219.349,566.494a.372.372,0,1,1-.261.107.369.369,0,0,1,.261-.107m0-.7a1.075,1.075,0,1,0,.765.319,1.072,1.072,0,0,0-.765-.319Z",
    transform: "translate(-1218.274 -565.79)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/Channel.114a19e8b114ade251b8d0a24a639dc2.svg";
export { ForwardRef as ReactComponent };